var $b542014dd6f00ba1$exports = {};
$b542014dd6f00ba1$exports = {
    "collectionLabel": `Suggerimenti`
};


export {$b542014dd6f00ba1$exports as default};
//# sourceMappingURL=it-IT.mjs.map
